import React, { useEffect, useState } from "react";
import ModalNew from "../../Modal/modal-new";
import { Col, DatePicker, Row } from "antd";
import InputWrapper from "../../Input/Input-Wrapper";
import CustomInput from "../../Input/Custom-Input";
import TextArea from "antd/es/input/TextArea";
import CustomizeButton from "../../Button/Customize-Button";
import { changePassword, getUserProfile, updateProfile } from "../../../Api/apiService";
import { toast } from "react-toastify";
import dayjs from "dayjs";

const ProfileModal = ({ visible, onClose }) => {
  const user = JSON.parse(localStorage.getItem("auth"));
  console.log(user, "this is user");
  const name = user.name.split(" ");
  const firstName = name[0];
  const lastName = name[1];
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
  });
  const [profileData, setProfileData] = useState({
    phone: "",
    address: "",
    dob: "",
    gender: "",
    bio: "",
  });
  useEffect(() => {
    getProfileDetails(user.userId);
  }, []);

  const handleInputChange = (field) => (e) => {
    setProfileData({
      ...profileData,
      [field]: e.target.value,
    });
  };
  const handleSaveProfile = async () => {
    try {
      const response = await updateProfile(user.userId, profileData);
      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "Profile updated successfully.", {
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
    onClose();
  };
  const getProfileDetails = async (profileId) => {
    try {
      const response = await getUserProfile(profileId);

      const { phone, address, dob, gender, bio } = response.data;

      setProfileData({
        phone: phone || "",
        address: address || "",
        dob: dob || "",
        gender: gender || "",
        bio: bio || "",
      });
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };
  const handleCurrentPassword = (e) => {
    setPasswordData({
      ...passwordData,
      currentPassword: btoa(e.target.value),
    });
  };
  const handleNewPassword = (e) => {
    setPasswordData({
      ...passwordData,
      newPassword: btoa(e.target.value),
    });
  };

  const submitChangePassword = async () => {
    try {
      const response = await changePassword(user.userId, passwordData);
      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "Password changed successfully.", {
          autoClose: 2000,
        });
        setChangePasswordModal(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const handleDateChange = (date, dateString) => {
    setProfileData((prev) => ({
      ...prev,
      dob: dateString,
    }));
  };

  return (
    <div>
      <ModalNew className="profile-modal" title={"My Profile"} visible={visible} onClose={onClose}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Row
            style={{
              width: "100%",
            }}
          >
            <Col
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                paddingRight: "10px",
              }}
              span={12}
            >
              <InputWrapper label={"First Name"} required>
                <CustomInput value={firstName} className="role-selector" />
              </InputWrapper>
              <InputWrapper label={"Email"} required>
                <CustomInput value={user.email} className="role-selector" />
              </InputWrapper>
              <InputWrapper label={"Date of Birth"} required>
                <DatePicker
                  onChange={handleDateChange}
                  style={{
                    height: "46px",
                    borderRadius: "10px",
                    border: "1px solid #E8E8E8",
                    boxShadow: "none",
                    width: "100%",
                  }}
                  value={profileData.dob ? dayjs(profileData.dob, "DD-MM-YYYY") : null}
                  format="DD-MM-YYYY"
                  placeholder="Select Date of Birth"
                />
              </InputWrapper>
            </Col>
            <Col
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                paddingRight: "10px",
              }}
              span={12}
            >
              <InputWrapper label={"Last Name"} required>
                <CustomInput value={lastName} className="role-selector" />
              </InputWrapper>
              <InputWrapper label={"Contact No."} required>
                <CustomInput
                  value={profileData.phone}
                  className="role-selector"
                  onChange={(e) =>
                    setProfileData((prev) => ({
                      ...prev,
                      phone: e.target.value,
                    }))
                  }
                />
              </InputWrapper>
              <InputWrapper label={"Gender"} required>
                <CustomInput
                  value={profileData.gender}
                  className="role-selector"
                  onChange={(e) =>
                    setProfileData((prev) => ({
                      ...prev,
                      gender: e.target.value,
                    }))
                  }
                />
              </InputWrapper>
            </Col>
          </Row>
          <Row>
            <InputWrapper
              style={{
                width: "100%",
              }}
              label={"Address"}
              required
            >
              <CustomInput
                value={profileData.address}
                className="role-selector"
                onChange={(e) =>
                  setProfileData((prev) => ({
                    ...prev,
                    address: e.target.value,
                  }))
                }
              />
            </InputWrapper>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <InputWrapper
              style={{
                width: "100%",
              }}
              label={"Bio"}
            >
              <TextArea
                value={profileData.bio}
                onChange={(e) =>
                  setProfileData((prev) => ({
                    ...prev,
                    bio: e.target.value,
                  }))
                }
                style={{
                  border: "1px solid #E8E8E8",
                  borderRadius: "10px",
                  width: "100%",
                  height: "20vh",
                  padding: "12px",
                  resize: "none",
                }}
                placeholder="Write something about yourself..."
              />
            </InputWrapper>
          </Row>
          <Row
            style={{
              display: "flex",
              gap: "10px",
              width: "100%",
            }}
          >
            <CustomizeButton
              style={{
                flex: 1,
              }}
              variant="primary"
              onClick={() => {
                handleSaveProfile();
              }}
            >
              Save
            </CustomizeButton>
            <CustomizeButton
              onClick={() => {
                setChangePasswordModal(true);
              }}
              style={{
                flex: 1,
              }}
              variant="outlined"
            >
              Change Password
            </CustomizeButton>
            <CustomizeButton
              style={{
                flex: 1,
              }}
              variant="outlined"
              onClick={onClose}
            >
              Cancel
            </CustomizeButton>
          </Row>
        </div>
      </ModalNew>

      <ModalNew
        title={"Change Password"}
        visible={changePasswordModal}
        onClose={() => {
          setChangePasswordModal(false);
        }}
      >
        <div className="selector-container">
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexDirection: "column",
            }}
          >
            <InputWrapper label="Enter Current Password" required>
              <CustomInput type="password" onChange={(e) => handleCurrentPassword(e)} className="role-selector" />
            </InputWrapper>
            <InputWrapper label="Enter New Password" required>
              <CustomInput type="password" className="role-selector" onChange={(e) => handleNewPassword(e)} />
            </InputWrapper>
          </div>
          <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
            <CustomizeButton className="navigate-btn" variant="primary" onClick={submitChangePassword}>
              {" "}
              Change{" "}
            </CustomizeButton>
            <CustomizeButton className="navigate-btn" variant="outlined">
              {" "}
              Cancel{" "}
            </CustomizeButton>
          </div>
        </div>
      </ModalNew>
    </div>
  );
};

export default ProfileModal;
